import { NgModule } from '@angular/core';

import { ErrorMessagesModal, SimpleFileUploaderComponent } from './simple-file-uploader.component';
import {PublicImageUploaderComponent} from './public-image-uploader.component';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CommonModule} from '@angular/common';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { StringFormatPipe } from '@app/core/pipes/stringFormat.pipe';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
  ],
    exports: [
      SimpleFileUploaderComponent,
        PublicImageUploaderComponent,
    ],
    declarations: [
      SimpleFileUploaderComponent,
      PublicImageUploaderComponent,
      ErrorMessagesModal,
    ],
    providers: [
      StringFormatPipe,
    ],
})
export class SimpleFileUploaderModule { }
